import {FormControl,
  InputLabel, MenuItem, Select} from '@mui/material';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React from 'react';
import {useCreateOrganizationLicenseDrawerState} from '../state/create-organization-license-drawer-state';

export type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void
  createOrganizationLicense: (licenseType: string, licenseExpiredDate: string, discount: number) => Promise<void>
}

export const CreateOrganizationLicenseDrawer = (props: Props) => {
  const state = useCreateOrganizationLicenseDrawerState(props)

  // Typ konta pod umowe (Dystrybutor/Producent/...), niezalezny od ficzerow.
  const buildLicenseType = () => <FormControl fullWidth>
    <InputLabel id="demo-simple-select-label">{state.translateLocal('licenseType.title')}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={state.selectedLicenseType}
      label={state.translateLocal('licenseType.label')}
      onChange={event => state.setSelectedLicenseType(event.target.value)}
    >
      {state.licenseTypes.map(it => <MenuItem key={it} value={it}>{state.translate(`licenseType.${it}`)}</MenuItem>)}
    </Select>
  </FormControl>

  const buildDiscount = () => <TextField
    label={state.translateLocal('discount.label')}
    type="number"
    value={state.discount}
    onChange={(e) => state.setDiscount(e.target.value)}
    fullWidth
    InputProps={{ endAdornment: '%' }}
  />

  const buildLicenseExpiredDate = () =>  <TextField
    label={state.translateLocal('expiredDate.label')}
    type="date"
    value={state.expiredDate}
    onChange={(e) => state.setExpiredDate(e.target.value)}
    fullWidth
    InputLabelProps={{
      shrink: true,
    }}
  />

  return <Drawer
    anchor="right"
    open={props.isDrawerOpen}
    onClose={state.closeDrawer}
    PaperProps={{
      sx: {
        width: 480,
        marginTop: '64px',
        height: `calc(100% - 64px)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <h2>{state.translateLocal('title')}</h2>
    <form onSubmit={async (event) => {
      event.preventDefault();
      await state.handleSubmit()
    }}>
      <Stack spacing={3}>
        {buildLicenseType()}
        {buildLicenseExpiredDate()}
        {buildDiscount()}
        <Button type="submit" variant="contained" color="primary" disabled={state.saveButtonDisabled}>
          {state.translate('common.save.title')}
        </Button>
        <Button variant="outlined" onClick={state.closeDrawer}>
          {state.translate('common.cancel.title')}
        </Button>
      </Stack>
    </form>
  </Drawer>
}